<template>
  <div>
    <div class="page-title mb-4">{{test && test.subject}}</div>
    <div v-if="test">
      <div class="clearfix">
        <div class="float-left">
          <span class="bolder">평가일</span>
          <date-picker2 v-model="test.testDate"/>
        </div>
        <div class="float-right">
          <back-btn-sm class="mr-1">돌아가기</back-btn-sm>
          <save-btn-sm class="mr-1" @click="onSave">저장</save-btn-sm>
          <delete-btn-sm class="mr-1" @click="onDelete">삭제</delete-btn-sm>
        </div>
      </div>
      <div v-for="(t, i) in test.evals" :key="i">
        <div class="bolder">평가구분</div>
        <div class="clearfix">
          <input class="underline" v-model="t.category" style="width:90%"/>
          <delete-btn-sm class="float-right" @click="test.evals.splice(i,1)"/>
        </div>
        <mdb-row>
          <mdb-col md="2" class="bolder text-right">평가항목</mdb-col>
          <mdb-col md="10">
            <div v-for="(item, ix) in t.items" :key="ix">
              <input class="underline" v-model="item.text" style="width:90%"/>
              <delete-btn-sm class="float-right" @click="t.items.splice(ix, 1)"/>
            </div>
            <add-btn-sm @click="t.items.push({text: ''})">항목 추가</add-btn-sm>
          </mdb-col>
        </mdb-row>
      </div>
      <add-btn-sm class="mt-3" @click="test.evals.push({category: '', items: []})">평가 구분 추가</add-btn-sm>
    </div>
  </div>
</template>
<script>
import { mdbTabs } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Training from '@/models/Training'
export default {
  name: 'StaffOpenTrainingPortfolioEdit',
  data () {
    return {
      TAG: 'StaffOpenTrainingPortfolioEdit >>',
      id: this.$route.query._id,
      test: undefined
    }
  },
  computed: {
  },
  methods: {
    // subjects와 문제지 맵 로드
    async load () {
      const _id = this.id
      if (_id === 'new') {
      } else {
        this.test = await this.$PortfolioTest.get(_id)
      }
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      this.test = await this.test.save()
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      await this.test.delete()
      this.$router.back()
    }
  },
  created () {
    this.load()
  }
}
</script>
